import React, { useEffect, useState, useCallback } from "react";
import { Save } from "lucide-react";
import {
  getStationDeliveryHours,
  StationDeliveryHoursPost,
} from "../../../server/DeliveryTimeEdit";
import showAlert from "../../../server/ShowAlert";
import { useDispatch, useSelector } from "react-redux";
import { setPreload } from "../../../server/CartsOpen";

const DeliveryHoursCalc = () => {
  const dispatch = useDispatch();
  const [deliveriesHourMinimum, setDeliveriesHourMinimum] = useState("");
  const [deliveriesTimeBefore, setDeliveriesTimeBefore] = useState("");
  const [quantityDeliveriesHour, setQuantityDeliveriesHour] = useState("");
  const stationId = useSelector((state) => state.user.stationId);
  const GetStationDeliveryHours = useCallback(() => {
    getStationDeliveryHours(stationId)
      .then((x) => {
        setDeliveriesHourMinimum(x.data.DeliveriesHourMinimum);
        setDeliveriesTimeBefore(x.data.DeliveriesTimeBefore);
        setQuantityDeliveriesHour(x.data.QuantityDeliveriesHour);
      })
      .catch(() => console.log("error"));
  }, [stationId]);

  useEffect(() => {
    GetStationDeliveryHours();
  }, [GetStationDeliveryHours]);

  const saveChanges = (
    deliveriesHourMinimum,
    deliveriesTimeBefore,
    quantityDeliveriesHour,
  ) => {
    dispatch(setPreload(true));
    const changeHours = {
      Id: stationId,
      QuantityDeliveriesHour: quantityDeliveriesHour,
      DeliveriesHourMinimum: deliveriesHourMinimum,
      DeliveriesTimeBefore: deliveriesTimeBefore,
    };
    StationDeliveryHoursPost(changeHours)
      .then((x) => {
        if (x.data) {
          showAlert({ msgTitle: "השינויים נשמרו בהצלחה.", msgType: "success" });
        }
      })
      .catch(() => console.log("error"))
      .finally(() => dispatch(setPreload(false)));
  };

  return (
    <section className="delivery-hours-calc admin-panel">
      <h2 className="admin-section-title">הגדרות תזמון</h2>
      <div className="delivery-hours-calc__grid">
        <label className="delivery-field">
          <span className="delivery-field__label">מספר הזמנות שאפשר בשעה</span>
          <input
            type="number"
            className="admin-input delivery-field__input"
            value={quantityDeliveriesHour}
            onChange={(e) => setQuantityDeliveriesHour(e.target.value)}
          />
        </label>
        <label className="delivery-field">
          <span className="delivery-field__label">
            מספר שעות מינימום לפני הגעת המשלוח
          </span>
          <input
            type="number"
            className="admin-input delivery-field__input"
            value={deliveriesHourMinimum}
            onChange={(e) => setDeliveriesHourMinimum(e.target.value)}
          />
        </label>
        <label className="delivery-field">
          <span className="delivery-field__label">כמה ימים להציג</span>
          <input
            type="number"
            className="admin-input delivery-field__input"
            value={deliveriesTimeBefore}
            onChange={(e) => setDeliveriesTimeBefore(e.target.value)}
          />
        </label>
      </div>
      <div className="delivery-hours-calc__actions">
        <button
          type="button"
          className="admin-btn-primary"
          onClick={() =>
            saveChanges(
              deliveriesHourMinimum,
              deliveriesTimeBefore,
              quantityDeliveriesHour,
            )
          }
        >
          <Save aria-hidden size={16} strokeWidth={2} />
          שמור
        </button>
      </div>
    </section>
  );
};

export default DeliveryHoursCalc;
